import { Component, OnInit, Input, ViewEncapsulation, AfterViewChecked } from '@angular/core';
import { VsTabmenuIntegrationService } from '@app/widget/vs-tabmenu-integration.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-vs-tab-new',
  templateUrl: './vs-tab-new.component.html',
  styleUrls: [ './vs-tab-new.component.scss' ],
  encapsulation: ViewEncapsulation.None
})
export class VsTabNewComponent implements OnInit, AfterViewChecked {


  public tabConfig: any;
  public tabHeight = {
    height: '0px'
  };

  constructor(private tabMenuIntegration: VsTabmenuIntegrationService, private router: Router) { }

  isAlreadyNavigated: boolean;
  firstPath: string;

  checkIfDetailPage(path, url) {
    if (!path) return false;
    const detailPagePath = path.substring(path.lastIndexOf('fp=') + 3);
    if (detailPagePath.length && url.indexOf("/" + detailPagePath) > -1) {
      return true;
    }
    return false;
  }

  navigateToFirstPath(tab, url): void {
    if (tab.path && (url.indexOf(tab.path) == -1) && !this.isAlreadyNavigated) {
      console.log('tab.path ', tab.path);
      this.router.navigateByUrl(tab.path);
      this.isAlreadyNavigated = true;
      this.firstPath = tab.path;
    } else if (tab.path && (this.checkIfDetailPage(tab.path, url)) && !this.isAlreadyNavigated) {
      let urlToNavigate = url;
      if (/(http(s?)):\/\//gi.test(url)) {
        urlToNavigate = window.location.hash.substring(1);
      }
      this.router.navigateByUrl(urlToNavigate);
      this.isAlreadyNavigated = true;
    } else if (tab.path && !this.firstPath) {
      this.firstPath = tab.path;
    }

    const iterator = tab.subTabs ? tab.subTabs : Array.isArray(tab) ? tab : [];
    if (iterator) {
      iterator.map(subtab => {
        if (!this.firstPath)
          this.navigateToFirstPath(subtab, url);
      });
    }
  }

  enableTab(tabConfig, firstPath) {
    tabConfig.map(tab => {
      if (tab.pathsInvolved && tab.pathsInvolved.length > 0) {
        for (let j = 0;j < tab.pathsInvolved.length;j++) {
          if (tab.pathsInvolved[ j ] === firstPath || this.checkIfDetailPage(firstPath, tab.pathsInvolved[ j ])) {
            tab.active = true;
            this.enableTab(tab.subTabs, firstPath);
          } else {
            tab.active = false;
          }
        }
      }
      if (tab.tab && tab.path === firstPath || this.checkIfDetailPage(firstPath, tab.path)) {
        tab.active = true;
      } else {
        tab.active = false;
      }
    });

  }

  subscribeForTabChanges() {
    this.tabMenuIntegration.tabChanges.subscribe(tab => {
      const href = window.location.href;
      if (tab && tab.length) {
        this.tabConfig = tab;
        this.firstPath = '';
        if (!this.isAlreadyNavigated) {
          console.log('First Path ', this.firstPath);
          if (!this.firstPath) {
            this.firstPath = href.split('#')[ 1 ];
            this.enableTab(this.tabConfig, this.firstPath);
          }
          this.router.navigateByUrl(this.firstPath);
        }
        this.isAlreadyNavigated = false;
      } else {
        this.tabConfig = [];
        this.router.navigateByUrl(href.split('#')[ 1 ]);
      }
    });
  }

  removeAllActive() {
    this.tabConfig.map(tb => {
      tb.active = false;
      this.removeAllActiveSubtabs(tb);
    });
  }
  removeAllActiveSubtabs(tabConfig) {
    if (!tabConfig.subTabs) {
      return;
    }
    tabConfig.subTabs.map(tb => {
      tb.active = false;
    });
  }

  handleTabClick(tab, tabConfig, tabGrandConfig?) {
    this.removeAllActive();
    tab.active = true;
    this.router.navigate([ tab.path ]);
    if (tab.subTabs) {
      tab.subTabs[ 0 ].active = true;
    }
    this.tabMenuIntegration.changeTab({
      subTabs: tabGrandConfig ? tabGrandConfig : tabConfig
    });
  }

  handleSubTabClick(tab, tabConfig, tabGrandConfig?) {
    console.log('tab :: ', tab, tabConfig);
    this.removeAllActiveSubtabs(tabConfig);
    tab.active = true;
  }

  getHeight() {
    const firstLevel = document.querySelector('.tab-fl');
    const secondLevel = document.querySelector('.tab-sl');

    return (firstLevel && secondLevel)
      ? '80px'
      : (!firstLevel && !secondLevel)
        ? '0'
        : '45px';
  }

  ngOnInit() {
    this.subscribeForTabChanges();
  }

  ngAfterViewChecked(): void {
    this.tabHeight.height = this.getHeight();
  }

}
